import { Heatmap } from '@antv/g2plot';
import React, { useEffect } from 'react'

import { TIME } from '../../../../services/util'

  const TIME_CATEGORIES = [
  '1-6 AM',
  '7-9 AM',
  '10 AM-12 PM',
  '1-3 PM',
  '4-6 PM',
  '7-9 PM',
  '9 PM-12 AM',
];

const getTimeCategoryFromHour = (hour) => {
  if (hour >= 1 && hour <= 6) return '1-6 AM';
  if (hour >= 7 && hour <= 9) return '7-9 AM';
  if (hour >= 10 && hour <= 12) return '10 AM-12 PM';
  if (hour >= 13 && hour <= 15) return '1-3 PM';
  if (hour >= 16 && hour <= 18) return '4-6 PM';
  if (hour >= 19 && hour <= 21) return '7-9 PM';
  if (hour >= 22 || hour === 0) return '9 PM-12 AM';
  return ''; 
};


const HeatmapChart = ({ sum }) => {

  useEffect(() => {

     const newSum = sum
     .map(s => {
        const value = 1
        return {
            day: TIME.parseDate(s.startTime),
            time: TIME.parseTimeChart(s.startTime),
            value: value,
        }});


    const uniqueDays = [...new Set(newSum.map(d => d.day))];

    const filledData = [];

    uniqueDays.forEach(day => {
      TIME_CATEGORIES.forEach(time => {
        const matchedItems = newSum.filter(d => {
          const hour = parseInt(d.time.split(':')[0], 10);
          const mapped = getTimeCategoryFromHour(hour);
          return d.day === day && mapped === time;
        });

        const totalValue = matchedItems.reduce((sum, item) => sum + item.value, 0);

        filledData.push({
          day,
          time,
          value: totalValue,
        });
      });
    });

    const chart = new Heatmap('heatmap-container', {
      data: filledData,
      xField: 'day',
      yField: 'time',
      colorField: 'value',
      sizeField: 'value',
      shape: 'square',
      color: ['#dddddd', '#9ec8e0', '#5fa4cd', '#2e7ab6', '#114d90'],
      label: {
        style: {
          fill: '#fff',
          shadowBlur: 2,
          shadowColor: 'rgba(0, 0, 0, .45)',
        },
      },
       yAxis: {
        type: 'cat',
      },
      // yAxis: {
      //   label: {
      //     formatter: (time) => {
      //       const [hourStr] = String(time).split(':');
      //       const hour = parseInt(hourStr, 10);

      //       if (hour >= 1 && hour <= 6) return '1-6 AM';
      //       if (hour >= 7 && hour <= 9) return '7-9 AM';
      //       if (hour >= 10 && hour <= 12) return '10 AM-12 PM';
      //       if (hour >= 13 && hour <= 15) return '1-3 PM';
      //       if (hour >= 16 && hour <= 18) return '4-6 PM';
      //       if (hour >= 19 && hour <= 21) return '7-9 PM';
      //       if (hour >= 22 || hour === 0) return '9 PM-12 AM';

      //     }
      // }}
    });

    chart.render();

    return () => {
      chart.destroy();
    };
  }, []);

  return <div id='heatmap-container' />;
};

export default React.memo(HeatmapChart)
